export const rootNode = document.getElementById('prospect-top-charts-publishers-root');

export const initParams = () => ({
  generalData: JSON.parse(rootNode.dataset.data),
  report: JSON.parse(rootNode.dataset.report),
  defaultOsName: rootNode.dataset.defaultOsName,
  store: rootNode.dataset.store,
  shareOptions: JSON.parse(rootNode.dataset.shareOptions),
  data: JSON.parse(rootNode.dataset.data),
  availableCategories: JSON.parse(rootNode.dataset.availableCategories),
});

export const parseUrlForFilters = () => {
  const { pathname, search } = window.location;
  const allFilters = pathname.match(
    /\/top-charts\/top-publishers\/(google-play|itunes-connect)\/([a-z-]+)?\/([a-z-]+)?/
  );
  const defaultFilters = pathname.match(/\/top-charts\/top-publishers/);
  const urlParams = new URLSearchParams(search);
  let filters = {};
  if (allFilters) {
    filters = { store: allFilters[1], category: allFilters[2], country: allFilters[3] };
  }

  if (!allFilters && defaultFilters) {
    filters = { store: defaultFilters[1] };
  }

  if (urlParams.get('date')) {
    filters = { ...filters, date: urlParams.get('date') };
  }

  return filters;
};
